import React from 'react'
import { ReactComponent as ArrowClickedUnfoldSvg} from '../../assets/svgs/arrows/Arrow_Clicked_Unfold.svg';

const ArrowClickedUnfoldIcon = () => (
    <div>
        <ArrowClickedUnfoldSvg/>
    </div>
)

export default ArrowClickedUnfoldIcon